import { firmClientKeys } from '../FirmClient';

function normalizeScorecardDateTime(dateTime: Date | null | undefined) {
  return dateTime ? dateTime.toISOString() : undefined;
}

export const scorecardKeys = {
  base: ['scorecard'],
  scorecard: (householdID: string | undefined | null, dateTime?: Date | null) => {
    const normalizedDateTime = normalizeScorecardDateTime(dateTime);

    return [
      ...scorecardKeys.base,
      ...firmClientKeys.household(householdID),
      ...(normalizedDateTime ? [normalizedDateTime] : []),
    ];
  },
  scorecardAtDate: (householdID: string | undefined, date: Date) => scorecardKeys.scorecard(householdID, date),
};
